"use client";

import { Eye, KeyRound, Loader2, MoreHorizontal, Pause, Pencil, Play, Trash2 } from "lucide-react";
import { Button } from "../button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../dropdown-menu";

interface ToggleActionConfig {
  isActive: boolean;
  activeLabel?: string;
  inactiveLabel?: string;
  onToggle: () => void;
  disabled?: boolean;
}

export interface DataTableRowActionsProps {
  onView?: () => void;
  onEdit?: () => void;
  onChangePassword?: () => void;
  onDelete?: () => void;
  toggle?: ToggleActionConfig;
  viewLabel?: string;
  editLabel?: string;
  changePasswordLabel?: string;
  deleteLabel?: string;
  disabled?: boolean;
  /** When true, the trigger shows a spinner and actions are blocked (e.g. row delete in flight). */
  isRowPending?: boolean;
}

export function DataTableRowActions({
  onView,
  onEdit,
  onChangePassword,
  onDelete,
  toggle,
  viewLabel = "Voir",
  editLabel = "Modifier",
  changePasswordLabel = "Modifier le mot de passe",
  deleteLabel = "Supprimer",
  disabled,
  isRowPending = false,
}: DataTableRowActionsProps) {
  const triggerDisabled = disabled || isRowPending;
  return (
    <div className="flex justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            size="sm"
            variant="ghost"
            className="h-8 w-8 p-0"
            aria-label="Actions"
            disabled={triggerDisabled}
          >
            {isRowPending ? (
              <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" aria-hidden />
            ) : (
              <MoreHorizontal className="h-4 w-4" />
            )}
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end" className="w-44">
          {onView && (
            <DropdownMenuItem onClick={onView} className="cursor-pointer">
              <Eye className="mr-2 h-4 w-4" />
              {viewLabel}
            </DropdownMenuItem>
          )}

          {onEdit && (
            <DropdownMenuItem onClick={onEdit} className="cursor-pointer">
              <Pencil className="mr-2 h-4 w-4" />
              {editLabel}
            </DropdownMenuItem>
          )}

          {/* {onChangePassword && (
            <>
              {(onView || onEdit) && <DropdownMenuSeparator />}
              <DropdownMenuItem onClick={onChangePassword} className="cursor-pointer">
                <KeyRound className="mr-2 h-4 w-4" />
                {changePasswordLabel}
              </DropdownMenuItem>
            </>
          )} */}

          {toggle && (
            <DropdownMenuItem
              onClick={toggle.onToggle}
              disabled={toggle.disabled}
              className="cursor-pointer"
            >
              {toggle.isActive ? (
                <>
                  <Pause className="mr-2 h-4 w-4" />
                  {toggle.activeLabel ?? "Désactiver"}
                </>
              ) : (
                <>
                  <Play className="mr-2 h-4 w-4" />
                  {toggle.inactiveLabel ?? "Activer"}
                </>
              )}
            </DropdownMenuItem>
          )}

          {onDelete && (
            <>
              {(onView || onEdit || onChangePassword || toggle) && <DropdownMenuSeparator />}
              <DropdownMenuItem
                onClick={onDelete}
                className="cursor-pointer text-destructive focus:text-destructive"
              >
                <Trash2 className="mr-2 h-4 w-4" />
                {deleteLabel}
              </DropdownMenuItem>
            </>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
